import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  Button,
  WideAlert,
  LoadingIndicator,
  Table,
  Checkbox,
  Icons,
} from '@components';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { SegundaViaBoletoService } from '@services';
import { useSelector } from 'react-redux';
import { mdiCommentAlertOutline } from '@mdi/js';

export const SegundaViaBoletoPage = () => {
  const navigate = useNavigate();
  const segundaViaBoletos = new SegundaViaBoletoService();
  const user = useSelector((state) => state.user);
  const [listaBoletos, setListaBoletos] = useState([]);
  const [loading, setLoading] = useState(false);

  const imprimirBoletos = () => {
    listaBoletos
      .filter((boleto) => boleto.checked)
      .map((boletosChecked) => {
        segundaViaBoletos
          .getBoletoCardeal(
            user.plano,
            boletosChecked.Nr_Proc,
            boletosChecked.Nr_Cobranca
          )
          .then((res) => {
            const blob = new Blob([res], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `Boleto ${boletosChecked.Nr_Proc}.PDF`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });

        return null;
      });
  };

  const recuperaBoletos = useCallback(() => {
    setLoading(true);

    segundaViaBoletos
      .getBoletosSegundaVia(user.matricula)
      .then((res) => {
        if (res.length !== 0) {
          const resWithCheckbox = res
            .filter((filtro) => filtro.Cd_Pln === user.plano)
            .map((item) => {
              return { ...item, checked: false };
            });
          setListaBoletos(resWithCheckbox);
        }
      })
      .catch(() => {
        toast.error('Erro ao carregar os dados de boletos');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [user.matricula, user.plano]);

  useEffect(() => {
    recuperaBoletos();
  }, [recuperaBoletos]);

  return !loading ? (
    <>
      <Helmet>
        <title>Forluz - Segunda via de boletos</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Segunda via de boleto</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          {listaBoletos.length === 0 ? (
            <WideAlert className="mb-4 mt-4" iconClear={false}>
              <div className="d-block d-lg-flex align-items-center">
                <Icons
                  path={mdiCommentAlertOutline}
                  color="var(--primary-color)"
                  size={2}
                  style={{ marginRight: 4 }}
                />
                <p className="ts-16">
                  <strong>Aviso importante:</strong> Não existem boletos para
                  emissão de segunda via.
                </p>
              </div>
            </WideAlert>
          ) : (
            <>
              <p className="ts-20 fw-bold mb-3 mt-32 mt-md-0">Boletos</p>
              <Table
                className=" mb-4 mt-32 col-12 col-md12 col-lg-6"
                odd
                columns={['Selecionar', 'Tipo', 'Valor']}
              >
                {listaBoletos.map((linha, index) => {
                  return (
                    <tr key={linha.Tipo}>
                      <td style={{ alignItems: 'center' }}>
                        <Checkbox
                          style={{ display: 'block' }}
                          defaultChecked={linha.checked}
                          onChange={() => {
                            setListaBoletos((prev) => {
                              const arrayAtualizado = prev.map((item, i) => {
                                if (index === i)
                                  return {
                                    ...item,
                                    checked: !item.checked,
                                  };
                                return item;
                              });
                              return arrayAtualizado;
                            });
                          }}
                        />
                      </td>
                      <td>{linha.Tipo}</td>
                      <td>{linha.Vr_Cob}</td>
                    </tr>
                  );
                })}
              </Table>
              {listaBoletos.find((boleto) => boleto.checked) && (
                <>
                  <p className="col-3 ts-16 fw-bold text-muted mb-3 mt-32 mt-md-0">
                    O que deseja fazer?
                  </p>
                  <div className="d-flex mt-2 col-3 col-md-2 col-lg-6 ">
                    <Button onClick={imprimirBoletos}>Visualizar</Button>
                    <Button className="ms-3">Enviar por e-mail</Button>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  ) : (
    <LoadingIndicator />
  );
};
